<template>
  <el-dialog
    :visible.sync="dialogueVisible"
    custom-class="dialogue-center-modal"
    width="92vw"
    top="4vh"
    :append-to-body="true"
    :modal-append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="true"
    @close="handleDialogClose"
  >
    <div class="dialogue-center">
      <section class="page" id="page-messages">
      <div class="chat">
        <div class="left-rail">
          <div class="chat-left">
            <div class="search">
              <el-input
                v-model.trim="chatSearch"
                class="input-like"
                placeholder="搜索联系人"
                clearable
              />
              <div style="margin-top: 10px">
                <el-switch
                  v-model="unreadFirst"
                  active-text="未读优先"
                  inactive-text="按最近排序"
                  @change="reorderChats"
                />
              </div>
            </div>

            <div class="chat-list">
              <div
                v-for="c in filteredChats"
                :key="c.id"
                class="chat-item"
                :class="{ active: c.id === selectedChatId }"
                @click="selectChat(c.id)"
              >
                <div style="display: flex; justify-content: space-between; gap: 12px">
                  <b>{{ getPeerDisplayName(c) }}</b>
                  <span v-if="(c.unreadCount || 0) > 0" class="badge blue">{{ c.unreadCount }}未读</span>
                  <span v-else class="badge">{{ (c.messages || []).length }}条</span>
                </div>
                <div class="sub">{{ c.subtitle }}</div>
                <div class="sub">
                  对象：{{ getPeerDisplayName(c) }}
                  <template v-if="getPeerUserId(c)">（ID: {{ getPeerUserId(c) }}）</template>
                </div>
                <div class="sub" v-if="c.lastMessageAt">最近消息：{{ formatConversationTime(c.lastMessageAt) }}</div>
                <div class="sub">{{ lastMessageText(c) }}</div>
              </div>

              <div v-if="!filteredChats.length" class="sub" style="padding: 10px 4px">
                没有匹配的对话。
              </div>
            </div>
          </div>
        </div>

        <div class="chat-main">
          <div class="chat-head">
            <div>
              <div style="font-size: 18px; font-weight: 800">
                {{ selectedChat ? getPeerDisplayName(selectedChat) : '请选择一个对话' }}
              </div>
              <div class="sub">
                {{ selectedChat ? selectedChat.subtitle : defaultChatSub }}
              </div>
              <div v-if="selectedChat" class="sub">
                对端：{{ getPeerDisplayName(selectedChat) }}
                <template v-if="getPeerUserId(selectedChat)">
                  （ID: {{ getPeerUserId(selectedChat) }})
                </template>
              </div>
            </div>
            <div style="display: flex; gap: 10px; align-items: center; flex-wrap: wrap">
              <el-button class="btn btn-secondary" @click="setQuick">快捷开场</el-button>
            </div>
          </div>

          <div ref="msgs" class="msgs">
            <div v-if="!selectedChat" class="sub" style="padding: 6px 2px">
              从左侧选择联系人开始沟通。
            </div>
            <div v-else-if="selectedChat.hasMoreHistory" style="padding: 0 0 8px 0">
              <el-button
                size="mini"
                class="btn btn-secondary"
                :loading="selectedChat.loadingHistory"
                @click="loadMoreHistory"
              >
                加载更早消息
              </el-button>
            </div>

            <div v-for="(m, idx) in selectedMessages" :key="messageRowKey(m, idx)">
              <div v-if="m.msgType === 'SYSTEM'" class="sys-row">
                <div class="sys-bubble" v-html="renderMessageHtml(m)"></div>
              </div>
              <div v-else class="msg-row" :class="[m.from]">
              <div class="msg-avatar" :class="[m.from]">
                <span class="msg-avatar-text">{{ m.from === 'me' ? (currentUserName || '我').slice(0, 1) : (selectedPeerDisplayName || '对').slice(0, 1) }}</span>
              </div>
              <div
                class="msg-bubble"
                :class="[m.from, { 'is-image': m.msgType === 'IMAGE', 'is-file': m.msgType === 'FILE' }]"
              >
                <template v-if="m.msgType === 'IMAGE' && m.attachment && m.attachment.url">
                  <img
                    class="chat-image"
                    :src="m.attachment.url"
                    alt="image"
                    @click="openImagePreview(m.attachment.url)"
                  />
                </template>
                <template v-else-if="m.msgType === 'FILE' && m.attachment && m.attachment.url">
                  <a class="chat-file" :href="m.attachment.url" target="_blank" rel="noopener">
                    <span class="chat-file-name">{{ m.attachment.name || '文件' }}</span>
                    <span class="chat-file-tip">点击打开</span>
                  </a>
                </template>
                <template v-else>
                  <span class="msg-text" v-html="renderMessageHtml(m)"></span>
                </template>
              </div>
              </div>
            </div>
          </div>

          <div class="chat-send">
            <div class="composer">
              <el-upload
                ref="attachmentUpload"
                class="attach-upload"
                :key="uploadKey"
                :action="uploadUrl"
                :show-file-list="false"
                :limit="1"
                accept="*/*"
                :before-upload="beforeChatUpload"
                :on-success="handleChatUploadSuccessAuto"
                :on-error="onChatUploadError"
              >
                <button type="button" class="composer-btn composer-btn-left" title="发送图片/附件">
                  <span class="composer-plus">+</span>
                </button>
              </el-upload>

              <el-input
                v-model.trim="chatInput"
                type="textarea"
                :rows="1"
                class="composer-input"
                placeholder="输入消息…"
                @keydown.enter.native.exact.prevent="sendMsg"
              />

              <button
                type="button"
                class="composer-btn composer-btn-right"
                :disabled="!canSend"
                title="发送"
                @click="sendMsg"
              >
                ↑
              </button>
            </div>
          </div>

          <el-dialog :visible.sync="imagePreviewVisible" width="860px" top="6vh">
            <div style="display: flex; justify-content: center; align-items: center; min-height: 240px">
              <img v-if="imagePreviewUrl" class="preview-image" :src="imagePreviewUrl" alt="preview" />
            </div>
          </el-dialog>
        </div>

        <div class="right-rail">
          <PublisherProfilePanel
            ref="publisherPanel"
            :enabled="!!selectedChat"
            :chat-kind="selectedChat ? String(selectedChat.chatKind || '') : ''"
            :entity-id="selectedChat ? String(selectedChat.entityId || '') : ''"
            :conversation-id="selectedChat ? String(selectedChat.conversationId || '') : ''"
            :target-user-id="selectedPeerUserId"
            :current-user-id="coerceSnowflakeString(currentUserId)"
            :target-display-name="selectedPeerDisplayName"
            :sender-user-id="selectedChat ? coerceSnowflakeString(selectedChat.senderUserId) : ''"
            :receiver-user-id="selectedChat ? coerceSnowflakeString(selectedChat.receiverUserId) : ''"
            :send-type="selectedChat ? String(selectedChat.sendType || '') : ''"
            :receive-type="selectedChat ? String(selectedChat.receiveType || '') : ''"
            @profile-view-sync="handleProfileViewSync"
          />
        </div>
      </div>
      </section>
    </div>
  </el-dialog>
</template>

<script>
import { parseSchemeDialogueRouteQuery } from '../utils/dialogue.js'
import { getToken } from '@/localCache/cookie'
import { fetchSchemeEcoCurrentUser, fetchSchemeUserByPhone } from '../api/user.js'
import { fetchSchemeCustomerList } from '../api/customer.js'
import { fetchSchemeOpportunityList } from '../api/opportunity.js'
import {
  createSchemeDialogueMessage,
  fetchSchemeConversationList,
  fetchSchemeDialogueMessagesByConversation,
  markSchemeConversationRead
} from '../api/dialogue.js'
import {
  normalizeSchemeDialogueMessage,
  normalizeSchemeDialogueSession,
  normalizeSnowflakeId,
  coerceSnowflakeString
} from '../adapters/dialogue.js'
import PublisherProfilePanel from './dialogueCenter/components/PublisherProfilePanel.vue'
import { maskPeerDisplayName, shouldMaskPeerDisplayForChat } from './dialogueCenter/utils/peerDisplay.js'

export default {
  name: 'SchemeEcosystemDialogueCenter',
  components: {
    PublisherProfilePanel
  },
  props: {
    embedded: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: true
    },
    launchQuery: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      dialogueVisible: this.visible,
      chatSearch: '',
      unreadFirst: true,
      selectedChatId: '',
      chatInput: '',
      pageSize: 30,
      ws: null,
      wsStatus: 'DISCONNECTED', // DISCONNECTED | CONNECTING | CONNECTED
      wsReconnectTimer: null,
      wsReconnectAttempts: 0,
      pollTimer: null,
      pollBaseIntervalMs: 4000,
      pollMaxIntervalMs: 16000,
      pollCurrentIntervalMs: 4000,
      pollIdleRounds: 0,
      polling: false,
      uploadUrl: process.env.VUE_APP_URL + 'longstron/base/doc/file/upload',
      uploadKey: 0,
      imagePreviewVisible: false,
      imagePreviewUrl: '',
      defaultChatSub:
        '为保护双方信息，系统默认先展示简称并支持线上沟通；确认合作意向后再交换完整联系方式。',
      chats: [],
      currentUserId: '',
      currentUserName: '',
      unreadReady: false
    }
  },
  computed: {
    filteredChats() {
      const q = (this.chatSearch || '').toLowerCase()
      const list = this.unreadFirst ? this.sortUnreadFirst(this.chats || []) : (this.chats || [])
      if (!q) return list
      return list.filter((x) =>
        `${x.name || ''} ${x.subtitle || ''} ${x.lastMessagePreview || ''}`.toLowerCase().includes(q)
      )
    },
    selectedChat() {
      const list = this.chats || []
      return list.find((x) => x.id === this.selectedChatId) || null
    },
    selectedPeerUserId() {
      if (!this.selectedChat) return ''
      return this.getPeerUserId(this.selectedChat) || ''
    },
    selectedPeerDisplayName() {
      if (!this.selectedChat) return ''
      return this.getPeerDisplayName(this.selectedChat) || ''
    },
    selectedMessages() {
      return (this.selectedChat && this.selectedChat.messages) || []
    },
    totalUnreadCount() {
      return (this.chats || []).reduce((sum, chat) => sum + Number(chat?.unreadCount || 0), 0)
    },
    canSend() {
      return !!this.selectedChatId && !!(this.chatInput || '').trim()
    }
  },
  watch: {
    visible(val) {
      this.dialogueVisible = !!val
    },
    dialogueVisible(val) {
      if (this.embedded) this.$emit('update:visible', !!val)
      if (val) {
        this.$nextTick(async () => {
          await this.loadMessagesForSelectedChat(false, true)
        })
      }
    },
    filteredChats: {
      handler(list) {
        if (!this.selectedChatId && list[0]) {
          this.selectedChatId = list[0].id
        }
      },
      immediate: true
    },
    selectedMessages() {
      this.$nextTick(this.scrollToBottom)
    },
    totalUnreadCount: {
      handler(val) {
        if (!this.unreadReady) {
          this.$emit('unread-change', 0)
          return
        }
        this.$emit('unread-change', Number(val || 0))
      },
      immediate: true
    },
    currentUserId(newVal, oldVal) {
      if (String(newVal || '') === String(oldVal || '')) return
      for (const c of this.chats || []) {
        if (!c || !Array.isArray(c.messages) || !c.messages.length) continue
        this.dedupeAndSortChatMessages(c)
      }
    }
  },
  methods: {
    normalizeSnowflakeId,
    coerceSnowflakeString,
    isSystemNoticeMessage(msg) {
      if (!msg) return false
      const msgType = String(msg.msgType || '').toUpperCase()
      const text = String(msg.text || '').trim()
      if (msgType === 'SYSTEM') return true
      return /^\[系统消息\]/.test(text)
    },
    async cleanupSystemUnreadConversations() {
      const list = (this.chats || []).filter(
        (c) => c && c.conversationId && Number(c.unreadCount || 0) === 1
      )
      for (const c of list) {
        try {
          const latest = await fetchSchemeDialogueMessagesByConversation(
            c.conversationId,
            false,
            1,
            null,
            null,
            {
              currentUserId: this.currentUserId
            }
          )
          const last = Array.isArray(latest) && latest.length ? latest[latest.length - 1] : null
          if (!last || !last.seqNum) continue
          if (!this.isSystemNoticeMessage(last)) continue
          await markSchemeConversationRead(c.conversationId, last.seqNum)
          c.unreadCount = 0
        } catch (e) {
          // 忽略单个会话异常，避免影响其他会话初始化
        }
      }
      this.reorderChats()
    },
    escapeHtml(text) {
      const s = text == null ? '' : String(text)
      return s
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
    },
    linkifyText(text) {
      const escaped = this.escapeHtml(text)
      // 支持 http(s):// 和 www. 开头的链接；末尾不吃常见标点
      const urlRe = /((https?:\/\/|www\.)[^\s<>"']+[^\s<>"'.,;:!?])/gi
      return escaped.replace(urlRe, (match) => {
        const raw = match
        const href = raw.toLowerCase().startsWith('http') ? raw : `https://${raw}`
        return `<a class="msg-link" href="${href}" target="_blank" rel="noopener noreferrer">${raw}</a>`
      })
    },
    renderMessageHtml(msg) {
      if (!msg) return ''
      if (msg.msgType === 'IMAGE' || msg.msgType === 'FILE') return ''
      return this.linkifyText(msg.text || '')
    },
    sourcePageLabel(sourcePage) {
      const key = String(sourcePage || '').trim()
      const map = {
        dashboard: '首页',
        opportunities: '商机推荐',
        'opportunities-ongoing': '商机沟通',
        'customer-recommendation': '客户推荐',
        'opportunity-recommendation': '商机推荐',
        'solution-exhibition': '解决方案展区',
        'resource-center': '资料中心',
        'authentication-center': '认证中心',
        'dialogue-center': '对话中心'
      }
      if (!key) return ''
      return map[key] || key
    },
    decorateSubtitleWithSource(chat, sourceLabel) {
      if (!chat || !sourceLabel) return chat
      const s = String(chat.subtitle || '').trim()
      if (!s || s === '从其他页面跳转' || s === '其他页面' || s === '-') {
        return { ...chat, subtitle: sourceLabel }
      }
      // 旧数据里有些是 “从其他页面跳转 · ...” 这种，保留后缀信息
      if (s.startsWith('从其他页面跳转')) {
        const rest = s.replace(/^从其他页面跳转\s*·?\s*/g, '')
        return { ...chat, subtitle: rest ? `${sourceLabel} · ${rest}` : sourceLabel }
      }
      return chat
    },
    handleDialogClose() {
      this.dialogueVisible = false
      if (this.embedded) {
        this.$emit('close')
        return
      }
      const fallbackRoute = { name: 'schemeEcosystem' }
      if (this.$route && this.$route.name === 'schemeEcosystemDialogueCenter') {
        this.$router.replace(fallbackRoute).catch(() => {})
        return
      }
      this.$router.push(fallbackRoute).catch(() => {})
    },
    toast(text) {
      if (!text) return
      if (this.$message) this.$message.info(text)
    },
    beforeChatUpload(file) {
      const maxMb = 20
      const ok = file && file.size / 1024 / 1024 < maxMb
      if (!ok) {
        this.$message && this.$message.error(`文件大小不能超过 ${maxMb}MB`)
        return false
      }
      return true
    },
    resetUpload() {
      this.$nextTick(() => {
        try {
          const u = this.$refs.attachmentUpload
          if (u && typeof u.clearFiles === 'function') u.clearFiles()
        } catch (e) {}
        // 双保险：某些情况下 clearFiles 不触发内部状态重置，用 key 强制重建
        this.uploadKey = Date.now()
      })
    },
    onChatUploadError() {
      this.toast('上传失败')
      this.resetUpload()
    },
    handleChatUploadSuccess(kind, res, file) {
      const url = res?.model?.httpFilePath || res?.model?.httpFileUrl || ''
      if (!url) {
        this.$message && this.$message.error('上传返回缺少文件路径')
        this.resetUpload()
        return
      }
      const raw = file?.raw || file || null
      const name = raw?.name || file?.name || ''
      const size = raw?.size || file?.size || 0
      this.sendAttachment(kind, { url, name, size })
      this.resetUpload()
    },
    handleChatUploadSuccessAuto(res, file) {
      const raw = file?.raw || file || null
      const type = String(raw?.type || file?.type || '').toLowerCase()
      const name = String(raw?.name || file?.name || '').toLowerCase()
      const ext = (name.match(/\.([a-z0-9]+)$/i) || [])[1] || ''
      const imageExts = new Set(['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp'])
      const isImage = type.startsWith('image/') || imageExts.has(ext)
      this.handleChatUploadSuccess(isImage ? 'IMAGE' : 'FILE', res, file)
    },
    openImagePreview(url) {
      if (!url) return
      this.imagePreviewUrl = url
      this.imagePreviewVisible = true
    },
    sendAttachment(kind, attachment) {
      const c = this.selectedChat
      if (!c || !c.conversationId) {
        this.$message && this.$message.info('请先选择一个对话')
        return
      }
      const receiverUserId = this.resolveReceiverUserId(c)
      const receiverName = this.resolveReceiverName(c)
      const typePair = this.resolveConversationTypePair(c)
      const msgType = kind === 'IMAGE' ? 'IMAGE' : 'FILE'
      const content = JSON.stringify({
        url: attachment?.url || '',
        name: attachment?.name || '',
        size: attachment?.size || 0
      })
      createSchemeDialogueMessage(
        {
          conversationId: c.conversationId,
          entityId: c.entityId,
          chatKind: c.chatKind,
          title: this.getChatDisplayName(c),
          subtitle: c.subtitle,
          senderUserId: this.currentUserId,
          senderName: this.resolveCurrentUserDisplayName(),
          receiverUserId,
          receiverName,
          sendType: typePair.sendType,
          receiveType: typePair.receiveType,
          msgType,
          content
        },
        { silent: true }
      )
        .then((res) => {
          this.applyResolvedConversationAfterSend(c, res)
          this.appendMessageFromSendApiResponse(c, res)
          c.unreadCount = 0
          return this.pollIncremental()
            .then(() => this.markChatAsRead(c))
            .then(() => {
              this.reorderChats()
            })
        })
        .catch(() => {
          if (this.$message) this.$message.error('发送失败')
        })
    },
    onVisibilityChange() {
      // 页面不可见时暂停轮询/WS 重连，避免后台持续刷请求
      if (document.hidden) {
        this.stopPolling()
      } else {
        // 回到可见：如果 WS 未连接则恢复轮询，并尝试重连
        if (this.wsStatus !== 'CONNECTED') this.startPolling()
        this.connectWs()
      }
    },
    buildWsUrl() {
      try {
        // WS 主机须与「实际发 HTTP 的后端」一致。
        // 1) 若 axios 的 BASE_API 为绝对 URL：默认用其主机；但部署在 test 等子域时，常误把 BASE_API 配成正式 open——此时与当前页不同源，应改跟 window.location（与网关反代一致）。
        // 2) 仅在本机/内网 dev 时，才允许用绝对 VUE_APP_URL 直连后端（页面 8088、接口 8089，避免 WS 打到 devServer）。
        let protocol = window.location.protocol === 'https:' ? 'wss' : 'ws'
        let host = window.location.host

        const parseHttpOrigin = (raw) => {
          const s = raw != null ? String(raw).trim() : ''
          if (!s || !/^https?:\/\//i.test(s)) return null
          try {
            const u = new URL(s)
            return {
              host: u.host,
              protocol: u.protocol === 'https:' ? 'wss' : 'ws'
            }
          } catch (e) {
            return null
          }
        }

        const pageHost = window.location.hostname
        const isLikelyLocalDev =
          pageHost === 'localhost' ||
          pageHost === '127.0.0.1' ||
          /^10\.\d+\.\d+\.\d+$/.test(pageHost) ||
          /^192\.168\.\d+\.\d+$/.test(pageHost)

        const apiFromBase = parseHttpOrigin(process.env.BASE_API)
        if (apiFromBase) {
          host = apiFromBase.host
          protocol = apiFromBase.protocol
          if (!isLikelyLocalDev && apiFromBase.host !== window.location.host) {
            protocol = window.location.protocol === 'https:' ? 'wss' : 'ws'
            host = window.location.host
          }
        } else {
          const apiFromVue = parseHttpOrigin(process.env.VUE_APP_URL)
          if (isLikelyLocalDev && apiFromVue) {
            host = apiFromVue.host
            protocol = apiFromVue.protocol
          }
        }
        // 浏览器 WebSocket 无法带 Authorization，握手用 query 传 JWT（与 MyTokenService / SchemeEcoChatWsHandshakeInterceptor 一致）
        const cookieToken = getToken()
        const lsToken =
          (typeof window !== 'undefined' && window.localStorage
            ? (window.localStorage.getItem('USER_TOKEN') || '')
            : '')
        const token = String(cookieToken || lsToken || '').trim()
        const qs = token ? `?token=${encodeURIComponent(token)}` : ''
        // REST 基础路径是 /longstron/...，WebSocket endpoint 注册为 /ws/schemeEcoChat（会自动挂在 contextPath 下）
        return `${protocol}://${host}/longstron/ws/schemeEcoChat${qs}`
      } catch (e) {
        return ''
      }
    },
    connectWs() {
      const url = this.buildWsUrl()
      if (!url) return
      if (this.wsStatus === 'CONNECTING' || this.wsStatus === 'CONNECTED') return

      this.wsStatus = 'CONNECTING'
      try {
        this.ws = new WebSocket(url)
      } catch (e) {
        this.wsStatus = 'DISCONNECTED'
        this.scheduleReconnect()
        return
      }

      this.ws.onopen = async () => {
        this.wsStatus = 'CONNECTED'
        this.wsReconnectAttempts = 0
        // WS 连上就停掉兜底轮询，避免影响输入体验
        this.stopPolling()
        await this.syncAfterReconnect()
      }
      this.ws.onmessage = (ev) => {
        const raw = ev && ev.data ? ev.data : ''
        void this.handleWsMessage(raw)
      }
      this.ws.onerror = () => {
        // onclose 会兜底重连
      }
      this.ws.onclose = () => {
        this.wsStatus = 'DISCONNECTED'
        this.ws = null
        // WS 断开就启用兜底轮询，保证无需手动刷新也能看到新消息
        this.startPolling()
        this.scheduleReconnect()
      }
    },
    closeWs() {
      if (this.wsReconnectTimer) {
        clearTimeout(this.wsReconnectTimer)
        this.wsReconnectTimer = null
      }
      try {
        if (this.ws) this.ws.close()
      } catch (e) {}
      this.ws = null
      this.wsStatus = 'DISCONNECTED'
    },
    startPolling() {
      if (this.pollTimer) return
      this.scheduleNextPoll(0)
    },
    stopPolling() {
      if (!this.pollTimer) return
      clearTimeout(this.pollTimer)
      this.pollTimer = null
      this.pollCurrentIntervalMs = this.pollBaseIntervalMs
      this.pollIdleRounds = 0
    },
    scheduleNextPoll(delayMs) {
      if (this.pollTimer) clearTimeout(this.pollTimer)
      this.pollTimer = setTimeout(async () => {
        this.pollTimer = null
        const hasNew = await this.pollIncremental()
        if (this.wsStatus === 'CONNECTED') return
        if (hasNew) {
          this.pollIdleRounds = 0
          this.pollCurrentIntervalMs = this.pollBaseIntervalMs
        } else {
          this.pollIdleRounds += 1
          const next = Math.min(
            this.pollMaxIntervalMs,
            this.pollBaseIntervalMs * Math.pow(2, Math.min(this.pollIdleRounds, 2))
          )
          this.pollCurrentIntervalMs = next
        }
        this.scheduleNextPoll(this.pollCurrentIntervalMs)
      }, Math.max(0, Number(delayMs || 0)))
    },
    async pollIncremental() {
      if (this.polling) return false
      if (typeof document !== 'undefined' && document.hidden) return false
      if (!this.dialogueVisible) return false
      // WS 已连上就不需要兜底轮询
      if (this.wsStatus === 'CONNECTED') return false
      this.polling = true
      try {
        // 兜底实时：只增量拉“当前会话”新消息，且静默（不触发全局 loading）
        const c = this.selectedChat
        if (!c || !c.conversationId) return false
        const last = c.messages && c.messages.length ? c.messages[c.messages.length - 1] : null
        const afterSeq = last && last.seqNum ? last.seqNum : 0
        const more = await fetchSchemeDialogueMessagesByConversation(c.conversationId, false, 50, null, afterSeq, {
          silent: true,
          currentUserId: this.currentUserId
        })
        if (more && more.length) {
          c.messages = [...(c.messages || []), ...more]
          this.dedupeAndSortChatMessages(c)
          const tail = c.messages.length ? c.messages[c.messages.length - 1] : null
          c.lastMessagePreview =
            tail && (tail.msgType === 'TEXT' || tail.msgType === 'SYSTEM')
              ? (tail.text || c.lastMessagePreview)
              : tail && tail.msgType === 'IMAGE'
                ? '[图片]'
                : tail && tail.msgType === 'FILE'
                  ? '[文件]'
                  : (tail?.text || c.lastMessagePreview)
          c.lastMessageAt = tail?.creationDate || c.lastMessageAt
          // 与 WS 打开时一致：正在查看的会话拉到新消息后同步服务端已读，避免仅靠本地清零、刷新后角标又回来
          if (tail && tail.seqNum) {
            try {
              await markSchemeConversationRead(c.conversationId, tail.seqNum)
            } catch (e) {
              // 忽略网络抖动
            }
          }
          c.unreadCount = 0
          this.$nextTick(this.scrollToBottom)
          return true
        }
        return false
      } catch (e) {
        return false
      } finally {
        this.polling = false
      }
    },
    scheduleReconnect() {
      if (this.wsReconnectTimer) return
      const base = 800
      const max = 8000
      const delay = Math.min(max, base * Math.pow(2, Math.min(4, this.wsReconnectAttempts || 0)))
      this.wsReconnectAttempts += 1
      this.wsReconnectTimer = setTimeout(() => {
        this.wsReconnectTimer = null
        this.connectWs()
      }, delay)
    },
    trySendAck(conversationId, seqNum) {
      if (!this.ws || this.wsStatus !== 'CONNECTED') return
      if (!conversationId || !seqNum) return
      try {
        this.ws.send(
          JSON.stringify({
            type: 'ACK',
            data: { conversationId, seqNum }
          })
        )
      } catch (e) {}
    },
    async syncAfterReconnect() {
      // 断线期间补拉：对每个会话按 lastSeq(afterSeq) 拉取新消息
      const list = this.chats || []
      for (const c of list) {
        if (!c || !c.conversationId) continue
        const last = c.messages && c.messages.length ? c.messages[c.messages.length - 1] : null
        const afterSeq = last && last.seqNum ? last.seqNum : 0
        const more = await fetchSchemeDialogueMessagesByConversation(c.conversationId, false, 200, null, afterSeq, {
          currentUserId: this.currentUserId
        })
        if (more && more.length) {
          c.messages = [...(c.messages || []), ...more]
          this.dedupeAndSortChatMessages(c)
          const tail = c.messages.length ? c.messages[c.messages.length - 1] : null
          c.lastMessagePreview =
            tail && (tail.msgType === 'TEXT' || tail.msgType === 'SYSTEM')
              ? (tail.text || c.lastMessagePreview)
              : tail && tail.msgType === 'IMAGE'
                ? '[图片]'
                : tail && tail.msgType === 'FILE'
                  ? '[文件]'
                  : (tail?.text || c.lastMessagePreview)
          c.lastMessageAt = tail?.creationDate || c.lastMessageAt
          const incomingCount = more.filter(
            (m) => String(m?.from || '') !== 'me' && !this.isSystemNoticeMessage(m)
          ).length
          // 未读：如果当前未选中该会话，则累计；选中则立刻标记已读
          if (String(c.id) !== String(this.selectedChatId) || !this.dialogueVisible) {
            c.unreadCount = Number(c.unreadCount || 0) + incomingCount
          } else {
            const last2 = c.messages.length ? c.messages[c.messages.length - 1] : null
            if (last2 && last2.seqNum) {
              await markSchemeConversationRead(c.conversationId, last2.seqNum)
              c.unreadCount = 0
            }
          }
        }
      }
      this.reorderChats()
    },
    async handleWsMessage(text) {
      if (!text) return
      let payload = null
      try {
        payload = JSON.parse(text)
      } catch (e) {
        return
      }
      const type = payload && payload.type ? String(payload.type) : ''
      const data = payload ? payload.data : null
      if (!type) return

      if (type === 'MESSAGE_NEW') {
        const convId = data?.conversationId
        const seqNum = data?.seqNum
        if (!convId) return
        let chat = (this.chats || []).find((x) => String(x.conversationId) === String(convId))
        if (!chat) {
          await this.mergeServerConversationList()
          chat = (this.chats || []).find((x) => String(x.conversationId) === String(convId))
        }
        if (!chat) return
        const msg = normalizeSchemeDialogueMessage(data, this.currentUserId)
        if (!msg) return
        const exists = (chat.messages || []).some((m) => String(m.seqNum) === String(msg.seqNum))
        if (!exists) chat.messages = [...(chat.messages || []), msg]
        this.dedupeAndSortChatMessages(chat)
        const tail = chat.messages.length ? chat.messages[chat.messages.length - 1] : msg
        chat.lastMessagePreview =
          tail.msgType === 'TEXT' || tail.msgType === 'SYSTEM'
            ? (tail.text || chat.lastMessagePreview)
            : tail.msgType === 'IMAGE'
              ? '[图片]'
              : '[文件]'
        chat.lastMessageAt = tail.creationDate || chat.lastMessageAt

        if (String(chat.id) === String(this.selectedChatId) && this.dialogueVisible) {
          // 当前会话：自动已读
          chat.unreadCount = 0
          if (msg.seqNum) markSchemeConversationRead(chat.conversationId, msg.seqNum)
          this.$nextTick(this.scrollToBottom)
        } else {
          // 只有“对方发来的消息”才应计入未读
          if (String(msg.from || '') !== 'me' && !this.isSystemNoticeMessage(msg)) {
            chat.unreadCount = Number(chat.unreadCount || 0) + 1
          }
        }
        this.reorderChats()
        this.trySendAck(convId, seqNum)
      } else if (type === 'CONVERSATION_READ') {
        const convId = data?.conversationId
        const lastReadSeq = data?.lastReadSeq
        if (!convId) return
        const chat = (this.chats || []).find((x) => String(x.conversationId) === String(convId))
        if (!chat) return
        // 简化：如果是当前会话读回执，则把未读清零
        if (String(chat.id) === String(this.selectedChatId)) {
          chat.unreadCount = 0
        } else {
          // 其他会话：不强行改未读（不同成员的 read 不一定等价于我的 unread）
        }
        if (lastReadSeq) this.trySendAck(convId, lastReadSeq)
        this.reorderChats()
      } else if (type === 'CONVERSATION_UPDATED') {
        const convId = data?.id
        if (!convId) return
        let chat = (this.chats || []).find((x) => String(x.conversationId) === String(convId))
        if (!chat) {
          await this.mergeServerConversationList()
          chat = (this.chats || []).find((x) => String(x.conversationId) === String(convId))
        }
        if (!chat) return
        chat.lastMessagePreview = data?.lastMessagePreview || chat.lastMessagePreview
        chat.lastMessageAt = data?.lastMessageAt || chat.lastMessageAt
        if (data?.unreadCount != null) {
          let u = Number(data.unreadCount || 0)
          if (String(chat.id) === String(this.selectedChatId) && this.dialogueVisible) {
            u = 0
          }
          chat.unreadCount = u
        }
        this.reorderChats()
      } else if (type === 'PROFILE_VIEW_UPDATED') {
        const bizType = data?.bizType != null ? String(data.bizType) : ''
        const bizEntityId = data?.bizEntityId != null ? String(data.bizEntityId) : ''
        const reqUid = normalizeSnowflakeId(data?.requesterUserId)
        const tgtUid = normalizeSnowflakeId(data?.targetUserId)
        const status = String(data?.status || '').toUpperCase()
        const me = normalizeSnowflakeId(this.currentUserId)

        if (status === 'APPROVED' && reqUid && me && reqUid === me) {
          this.unlockApprovedProfileViewForApplicant(bizType, bizEntityId, reqUid, tgtUid)
        }

        const c = this.selectedChat
        if (c && (!bizEntityId || String(c.entityId || '') === bizEntityId) && (!bizType || String(c.chatKind || '') === bizType)) {
          const panel = this.$refs.publisherPanel
          if (panel && typeof panel.refresh === 'function') {
            panel.refresh()
          }
        }
      }
    },
    sortUnreadFirst(list) {
      return [...(list || [])].sort((a, b) => {
        const ua = Number(a?.unreadCount || 0)
        const ub = Number(b?.unreadCount || 0)
        if (ua !== ub) return ub - ua
        const ta = String(a?.lastMessageAt || '')
        const tb = String(b?.lastMessageAt || '')
        return tb.localeCompare(ta)
      })
    },
    reorderChats() {
      const base = this.chats || []
      this.chats = this.unreadFirst ? this.sortUnreadFirst(base) : [...base]
    },
    lastMessageText(chat) {
      const ms = (chat && chat.messages) || []
      if (ms.length) return ms[ms.length - 1].text
      return chat && chat.lastMessagePreview ? chat.lastMessagePreview : ''
    },
    selectChat(id) {
      this.selectedChatId = id
      this.$nextTick(async () => {
        await this.loadMessagesForSelectedChat(false, true)
        this.scrollToBottom()
      })
    },
    formatConversationTime(text) {
      if (!text) return ''
      if (text.length <= 16) return text
      return text.slice(0, 16)
    },
    maskDisplayName(name) {
      return maskPeerDisplayName(name)
    },
    /**
     * 登录展示名与会话 sender/receiver 可能不一致（公司全称 vs「史总」、简称等），
     * 在雪花 ID 曾因 JSON 精度失效时仍要能推断「我是谁、对端是谁」。
     */
    namesLikelySame(a, b) {
      const x = String(a || '').trim()
      const y = String(b || '').trim()
      if (!x || !y) return false
      if (x === y) return true
      if (x.includes(y) || y.includes(x)) return true
      const fx = [...x][0]
      const fy = [...y][0]
      if (fx && fy && fx === fy && x.length <= 8 && y.length <= 8) return true
      return false
    },
    getPeerRawDisplayName(chat) {
      if (!chat) return '未命名联系人'
      const currentUserId = coerceSnowflakeString(this.currentUserId)
      const senderUserId = coerceSnowflakeString(chat.senderUserId)
      const receiverUserId = coerceSnowflakeString(chat.receiverUserId)
      const senderName = String(chat.senderName || '').trim()
      const receiverName = String(chat.receiverName || '').trim()
      const myName = String(this.resolveCurrentUserDisplayName() || '').trim()
      const peerUid = this.getPeerUserId(chat)
      if (peerUid && senderUserId && peerUid === senderUserId && senderName) return senderName
      if (peerUid && receiverUserId && peerUid === receiverUserId && receiverName) return receiverName
      if (currentUserId && receiverUserId === currentUserId && senderName) return senderName
      if (currentUserId && senderUserId === currentUserId && receiverName) return receiverName
      if (currentUserId && receiverUserId === currentUserId) {
        const fallback = String(chat.name || '').trim()
        if (fallback && fallback !== receiverName && fallback !== '待加载会话' && fallback !== '未命名会话') return fallback
      }
      if (currentUserId && senderUserId === currentUserId) {
        const fallback = String(chat.name || '').trim()
        if (fallback && fallback !== senderName && fallback !== '待加载会话' && fallback !== '未命名会话') return fallback
      }
      if (myName && receiverName && myName === receiverName && senderName) return senderName
      if (myName && senderName && myName === senderName && receiverName) return receiverName
      if (myName && receiverName && this.namesLikelySame(myName, receiverName) && senderName) return senderName
      if (myName && senderName && this.namesLikelySame(myName, senderName) && receiverName) return receiverName
      const name = String(chat.name || '').trim()
      if (name && name !== '待加载会话' && name !== '未命名会话') {
        if (
          this.namesLikelySame(myName, receiverName) &&
          senderName &&
          this.namesLikelySame(name, receiverName)
        ) {
          return senderName
        }
        if (
          this.namesLikelySame(myName, senderName) &&
          receiverName &&
          this.namesLikelySame(name, senderName)
        ) {
          return receiverName
        }
        return name
      }
      return '未命名联系人'
    },
    /**
     * 对端身份类型（与 PublisherProfilePanel.targetType 一致）；勿用 receiveType||sendType 兜底以免误判脱敏。
     */
    getPeerRoleType(chat) {
      if (!chat) return ''
      const sendType = String(chat.sendType || '').trim().toLowerCase()
      const receiveType = String(chat.receiveType || '').trim().toLowerCase()
      const me = coerceSnowflakeString(this.currentUserId)
      const sUid = coerceSnowflakeString(chat.senderUserId)
      const rUid = coerceSnowflakeString(chat.receiverUserId)
      if (me && sUid && me === sUid && receiveType) return receiveType
      if (me && rUid && me === rUid && sendType) return sendType
      const myName = String(this.resolveCurrentUserDisplayName() || '').trim()
      const sName = String(chat.senderName || '').trim()
      const rName = String(chat.receiverName || '').trim()
      if (myName && rName && myName === rName && sendType) return sendType
      if (myName && sName && myName === sName && receiveType) return receiveType
      if (myName && rName && this.namesLikelySame(myName, rName) && sendType) return sendType
      if (myName && sName && this.namesLikelySame(myName, sName) && receiveType) return receiveType
      return ''
    },
    /**
     * 仅当对端为企业（company）时脱敏；scheme/supplier 对端不脱敏。申请通过后解除（profileInfoUnlocked）。
     */
    shouldMaskPeerDisplayByPolicy(chat) {
      return shouldMaskPeerDisplayForChat(
        chat,
        this.currentUserId,
        this.resolveCurrentUserDisplayName(),
        coerceSnowflakeString
      )
    },
    unlockApprovedProfileViewForApplicant(chatKind, entityId, requesterUserId, targetUserId) {
      const k = chatKind ? String(chatKind).trim() : ''
      const eid = entityId ? String(entityId).trim() : ''
      const a = normalizeSnowflakeId(requesterUserId)
      const b = normalizeSnowflakeId(targetUserId)
      if (!a || !b) return
      ;(this.chats || []).forEach((c) => {
        if (!c) return
        if (eid && String(c.entityId || '').trim() !== eid) return
        if (k && String(c.chatKind || '').trim() !== k) return
        const sUid = normalizeSnowflakeId(c.senderUserId)
        const rUid = normalizeSnowflakeId(c.receiverUserId)
        const peersHit = (sUid === a && rUid === b) || (sUid === b && rUid === a)
        if (!peersHit) return
        this.$set(c, 'profileInfoUnlocked', true)
      })
    },
    handleProfileViewSync(payload) {
      if (String(payload?.viewStatus || '').toUpperCase() !== 'APPROVED') return
      const c = this.selectedChat
      if (!c || !payload) return
      if (payload.entityId && String(c.entityId || '').trim() !== String(payload.entityId).trim()) return
      if (payload.chatKind && String(c.chatKind || '').trim() !== String(payload.chatKind).trim()) return
      const tgt = normalizeSnowflakeId(payload?.targetUserId)
      if (tgt && normalizeSnowflakeId(this.getPeerUserId(c)) !== tgt) return
      this.$set(c, 'profileInfoUnlocked', true)
    },
    getPeerUserId(chat) {
      if (!chat) return ''
      const me = coerceSnowflakeString(this.currentUserId)
      const sUid = coerceSnowflakeString(chat.senderUserId)
      const rUid = coerceSnowflakeString(chat.receiverUserId)
      if (me && rUid && rUid === me) return sUid
      if (me && sUid && sUid === me) return rUid
      const myName = String(this.resolveCurrentUserDisplayName() || '').trim()
      const sName = String(chat.senderName || '').trim()
      const rName = String(chat.receiverName || '').trim()
      if (myName && rName && myName === rName && sUid) return sUid
      if (myName && sName && myName === sName && rUid) return rUid
      if (myName && rName && this.namesLikelySame(myName, rName) && sUid) return sUid
      if (myName && sName && this.namesLikelySame(myName, sName) && rUid) return rUid
      if (!me) return ''
      if (me && rUid && me !== rUid && !sUid) return rUid
      return ''
    },
    getPeerDisplayName(chat) {
      const raw = this.getPeerRawDisplayName(chat)
      if (!chat) return raw
      if (!this.shouldMaskPeerDisplayByPolicy(chat)) return raw
      return this.maskDisplayName(raw)
    },
    getChatDisplayName(chat) {
      return this.getPeerDisplayName(chat)
    },
    resolveCurrentUserDisplayName() {
      const storeUser = (this.$store && this.$store.getters && this.$store.getters.currentUser) || {}
      return String(
        this.currentUserName ||
        storeUser.name ||
        storeUser.realName ||
        storeUser.username ||
        storeUser.nickName ||
        storeUser.companyName ||
        ''
      ).trim()
    },
    setQuick() {
      if (!this.selectedChatId) {
        if (this.$message) this.$message.info('请先选择一个对话')
        return
      }
      this.chatInput = '您好，我看到了贵方当前的项目需求，方便简单沟通一下适配场景吗？'
    },
    applyResolvedConversationAfterSend(chat, res) {
      const model = res && res.model
      const cidFromModel =
        model && model.conversationId != null && String(model.conversationId).trim()
          ? String(model.conversationId).trim()
          : ''
      const cidFromResolved =
        res && res.resolvedConversationId != null && String(res.resolvedConversationId).trim()
          ? String(res.resolvedConversationId).trim()
          : ''
      const cid = cidFromModel || cidFromResolved
      if (!cid || !chat) return
      const oldId = chat.id
      chat.conversationId = cid
      chat.id = cid
      if (String(this.selectedChatId) === String(oldId)) this.selectedChatId = cid
      this.absorbDuplicateChatsForId(chat, cid)
    },
    /**
     * 同一 conversationId 只保留一行，合并消息，避免 WS 先插入列表行、HTTP 再升级 draft 时重复。
     * @param {object} keepChat 要保留的会话对象
     * @param {string} conversationId
     */
    absorbDuplicateChatsForId(keepChat, conversationId) {
      const cidStr = String(conversationId || '')
      if (!keepChat || !cidStr) return
      const next = []
      for (const x of this.chats || []) {
        if (!x) continue
        if (x !== keepChat && String(x.conversationId || '') === cidStr) {
          keepChat.messages = [...(keepChat.messages || []), ...(x.messages || [])]
          if (String(this.selectedChatId) === String(x.id)) this.selectedChatId = String(keepChat.id)
          continue
        }
        next.push(x)
      }
      this.chats = next
      this.dedupeAndSortChatMessages(keepChat)
    },
    /**
     * 列表渲染用稳定 key，避免仅用 idx 在插入/重排时导致气泡错乱。
     * @param {object} m
     * @param {number} idx
     * @returns {string}
     */
    messageRowKey(m, idx) {
      const seq = m && m.seqNum != null ? String(m.seqNum) : ''
      const id = m && m.id != null ? String(m.id) : ''
      if (seq) return `seq-${seq}`
      if (id) return `id-${id}`
      return `i-${idx}`
    },
    /**
     * 按 seqNum 去重并排序，避免 WS 与 HTTP 竞态导致重复或顺序错乱。
     * @param {object} chat
     */
    dedupeAndSortChatMessages(chat) {
      if (!chat || !Array.isArray(chat.messages) || !chat.messages.length) return
      const uid = coerceSnowflakeString(this.currentUserId)
      const refresh = (m) => {
        if (!m) return null
        const row = m.raw && typeof m.raw === 'object' ? m.raw : null
        if (!row) return m
        return normalizeSchemeDialogueMessage(row, uid) || m
      }
      const map = new Map()
      for (const m of chat.messages) {
        if (!m) continue
        const cur = refresh(m)
        if (!cur) continue
        const k =
          cur.seqNum != null && cur.seqNum !== ''
            ? String(cur.seqNum)
            : cur.id
              ? String(cur.id)
              : ''
        if (!k) continue
        if (!map.has(k)) {
          map.set(k, cur)
        } else {
          const prev = map.get(k)
          const prevRow = prev && prev.raw
          const curRow = cur && cur.raw
          const prevHas =
            prevRow &&
            prevRow.senderUserId != null &&
            String(prevRow.senderUserId).trim() !== ''
          const curHas =
            curRow && curRow.senderUserId != null && String(curRow.senderUserId).trim() !== ''
          const pickRaw = curHas && !prevHas ? curRow : prevRow || curRow
          map.set(k, pickRaw ? normalizeSchemeDialogueMessage(pickRaw, uid) : prev)
        }
      }
      const arr = [...map.values()].sort((a, b) => Number(a.seqNum || 0) - Number(b.seqNum || 0))
      chat.messages = arr
    },
    /**
     * 发送接口返回后立即把消息写入本地，避免「WS 先于 HTTP、且 WS 已连接不轮询」时首条不显示。
     * @param {object} chat
     * @param {object} res axios 业务响应
     */
    appendMessageFromSendApiResponse(chat, res) {
      if (!chat || !res || String(res.code || '') !== '00000') return
      const model = res.model
      if (!model) return
      const msg = normalizeSchemeDialogueMessage(model, this.currentUserId)
      if (!msg || !msg.seqNum) return
      const exists = (chat.messages || []).some((m) => String(m.seqNum) === String(msg.seqNum))
      if (!exists) {
        chat.messages = [...(chat.messages || []), msg]
      }
      this.dedupeAndSortChatMessages(chat)
      const tail = chat.messages.length ? chat.messages[chat.messages.length - 1] : null
      if (tail) {
        chat.lastMessagePreview =
          tail.msgType === 'TEXT' || tail.msgType === 'SYSTEM'
            ? (tail.text || chat.lastMessagePreview)
            : tail.msgType === 'IMAGE'
              ? '[图片]'
              : '[文件]'
        chat.lastMessageAt = tail.creationDate || chat.lastMessageAt
      }
    },
    /**
     * 当 WS 推送到达但本地还没有该会话行时，用服务端会话列表补齐（新会话首条、对端角标）。
     * @param {Array|null} serverChats 可选：已拉取的列表，避免重复请求
     */
    async mergeServerConversationList(serverChats) {
      let fresh = serverChats
      if (!fresh) {
        try {
          fresh = await fetchSchemeConversationList()
        } catch (e) {
          return
        }
      }
      if (!Array.isArray(fresh) || !fresh.length) return
      const byCid = new Map()
      for (const s of fresh) {
        const cid = String(s.conversationId || s.id || '')
        if (cid) byCid.set(cid, s)
      }
      const consumed = new Set()
      const next = []
      for (const c of this.chats || []) {
        if (!c) continue
        const cid = String(c.conversationId || '')
        if (cid && byCid.has(cid)) {
          const s = byCid.get(cid)
          consumed.add(cid)
          next.push({
            ...c,
            ...s,
            id: cid,
            conversationId: cid,
            messages: Array.isArray(c.messages) ? c.messages : [],
            hasMoreHistory: typeof c.hasMoreHistory === 'boolean' ? c.hasMoreHistory : s.hasMoreHistory,
            loadingHistory: false
          })
        } else {
          next.push(c)
        }
      }
      for (const [cid, s] of byCid) {
        if (!cid || consumed.has(cid)) continue
        next.push({ ...s, messages: [], hasMoreHistory: true, loadingHistory: false })
      }
      this.chats = next
      this.reorderChats()
    },
    sendMsg() {
      if (!this.canSend) return
      const c = this.selectedChat
      if (!c) return
      const receiverUserId = this.resolveReceiverUserId(c)
      const receiverName = this.resolveReceiverName(c)
      const typePair = this.resolveConversationTypePair(c)
      c.sendType = typePair.sendType || c.sendType || ''
      c.receiveType = typePair.receiveType || c.receiveType || ''
      this.prepareDraftConversation(c, {
        sourcePage: this.launchQuery?.sourcePage || this.$route?.query?.sourcePage || ''
      })
      if (!receiverUserId) {
        if (this.$message) this.$message.warning('当前会话缺少接收人ID，请重新从推荐列表发起会话')
        return
      }

      const content = this.chatInput.trim()
      this.chatInput = ''

      createSchemeDialogueMessage({
        conversationId: c.conversationId,
        entityId: c.entityId,
        chatKind: c.chatKind,
        title: this.getChatDisplayName(c),
        subtitle: c.subtitle,
        senderUserId: this.currentUserId,
        senderName: this.resolveCurrentUserDisplayName(),
        receiverUserId,
        receiverName,
        sendType: typePair.sendType,
        receiveType: typePair.receiveType,
        content
      }, { silent: true })
        .then((res) => {
          this.applyResolvedConversationAfterSend(c, res)
          this.appendMessageFromSendApiResponse(c, res)
          c.unreadCount = 0
          return this.pollIncremental()
            .then(() => this.markChatAsRead(c))
            .then(() => {
              this.reorderChats()
            })
        })
        .catch(() => {
          if (this.$message) this.$message.error('发送失败')
        })
    },
    async markChatAsRead(chat) {
      if (!chat || !chat.conversationId) return
      const ms = Array.isArray(chat.messages) ? chat.messages : []
      const last = ms.length ? ms[ms.length - 1] : null
      if (!last || !last.seqNum) {
        chat.unreadCount = 0
        return
      }
      try {
        await markSchemeConversationRead(chat.conversationId, last.seqNum)
      } catch (e) {
        // 忽略网络抖动，避免影响已读状态的本地回落
      }
      chat.unreadCount = 0
    },
    scrollToBottom() {
      const el = this.$refs.msgs
      if (!el) return
      el.scrollTop = el.scrollHeight
    },
    async loadMessagesForSelectedChat(force = false, shouldMarkRead = this.dialogueVisible) {
      const c = this.selectedChat
      if (!c || !c.entityId) return

      // 已有缓存消息时，仍需按需同步已读，避免“读过后刷新角标还在”
      if (!force && c.messages && c.messages.length) {
        if (shouldMarkRead) {
          await this.markChatAsRead(c)
          this.reorderChats()
        }
        return
      }

      if (!c.conversationId) {
        c.messages = c.messages || []
        c.hasMoreHistory = false
        return
      }
      const messages = await fetchSchemeDialogueMessagesByConversation(c.conversationId, false, this.pageSize, null, null, {
        currentUserId: this.currentUserId
      })
      // 确保 messages 是响应式的：直接赋值给 session 对象
      c.messages = messages
      c.hasMoreHistory = (messages || []).length >= this.pageSize
      c.loadingHistory = false
      if (shouldMarkRead) {
        await this.markChatAsRead(c)
      }
      this.reorderChats()
    },
    async loadMoreHistory() {
      const c = this.selectedChat
      if (!c || !c.conversationId || c.loadingHistory) return
      const first = c.messages && c.messages.length ? c.messages[0] : null
      if (!first || !first.seqNum) {
        c.hasMoreHistory = false
        return
      }
      c.loadingHistory = true
      try {
        const more = await fetchSchemeDialogueMessagesByConversation(
          c.conversationId,
          false,
          this.pageSize,
          first.seqNum,
          null,
          {
            currentUserId: this.currentUserId
          }
        )
        if (!more.length) {
          c.hasMoreHistory = false
          return
        }
        c.messages = [...more, ...(c.messages || [])]
        c.hasMoreHistory = more.length >= this.pageSize
      } finally {
        c.loadingHistory = false
      }
    },
    async initChats(chatKindFromRoute, entityIdFromRoute, routeReceiver = null) {
      const chatKind = chatKindFromRoute || 'customer'
      const entityId = entityIdFromRoute ? String(entityIdFromRoute) : ''
      const routeReceiverUserId = String(routeReceiver?.receiverUserId || '')

      let chats = await fetchSchemeConversationList()

      // 会话列表为空时不再自动预建，避免清库后被前端再次批量生成

      // route 里指定 entityId 时：优先选中，否则默认取第一个
      if (entityId) {
        const exactHit = chats.find((c) => {
          const sameEntity = String(c.entityId) === entityId && String(c.chatKind || '') === String(chatKind)
          if (!sameEntity) return false
          if (!routeReceiverUserId) return true
          return this.isSamePeerChat(c, routeReceiverUserId)
        })
        if (exactHit) {
          this.selectedChatId = exactHit.id
          return chats
        }

        // 某些入口 entityId 可能复用，补充“同联系人”兜底，避免命中到其他人
        if (routeReceiverUserId) {
          const peerHit = chats.find((c) => {
            if (String(c.chatKind || '') !== String(chatKind)) return false
            return this.isSamePeerChat(c, routeReceiverUserId)
          })
          if (peerHit) {
            this.selectedChatId = peerHit.id
            return chats
          }
        }

        // route 指定了对象但列表不存在时：仅占位前端会话，等用户发送首条消息再在后端建档
        const sourceLabel = this.sourcePageLabel(this.launchQuery?.sourcePage || this.$route?.query?.sourcePage || '')
        const routeSourcePayload = {
          id: entityId,
          entityId,
          name: routeReceiver?.receiverName || '未命名联系人',
          receiverName: routeReceiver?.receiverName || '',
          receiverUserId: routeReceiver?.receiverUserId || '',
          mobilePhone: routeReceiver?.receiverPhone || '',
          company: sourceLabel || '其他页面'
        }
        const placeholderRaw = normalizeSchemeDialogueSession(routeSourcePayload, chatKind, null)
        const placeholderId = routeReceiverUserId ? `${chatKind}-${entityId}-${routeReceiverUserId}` : placeholderRaw.id
        const tp = this.resolveConversationTypePair({})
        const placeholder = {
          ...placeholderRaw,
          id: placeholderId,
          sendType: tp.sendType || '',
          receiveType: tp.receiveType || '',
          hasMoreHistory: false,
          loadingHistory: false
        }
        if (!placeholder.id) return chats
        this.prepareDraftConversation(placeholder, {
          sourcePage: this.launchQuery?.sourcePage || this.$route?.query?.sourcePage || ''
        })
        this.selectedChatId = placeholder.id
        return [...chats, placeholder]
      }

      // 未指定 entityId 但带了联系人时，也应优先定位到该联系人历史会话
      if (routeReceiverUserId) {
        const peerHit = chats.find((c) => {
          if (String(c.chatKind || '') !== String(chatKind)) return false
          return this.isSamePeerChat(c, routeReceiverUserId)
        })
        if (peerHit) {
          this.selectedChatId = peerHit.id
          return chats
        }
      }

      if (chats[0]) this.selectedChatId = chats[0].id
      return chats
    },
    async resolveRouteReceiver(query) {
      const receiverUserId = String(query?.receiverUserId || '').trim()
      const receiverPhone = String(query?.receiverPhone || '').trim()
      const receiverName = String(query?.receiverName || '').trim()
      if (receiverUserId) {
        return {
          receiverUserId: normalizeSnowflakeId(receiverUserId) || String(receiverUserId).trim(),
          receiverPhone,
          receiverName
        }
      }
      if (receiverPhone) {
        const user = await fetchSchemeUserByPhone(receiverPhone)
        if (user?.userId) {
          return {
            receiverUserId: normalizeSnowflakeId(user.userId) || String(user.userId),
            receiverPhone: user.mobilePhone || receiverPhone,
            receiverName: user.name || receiverName
          }
        }
      }
      return null
    },
    resolveReceiverUserId(chat) {
      if (!chat) return ''
      const source = chat.source || {}
      const currentUserId = normalizeSnowflakeId(this.currentUserId)
      const receiverUserId =
        chat.receiverUserId ||
        source.receiverUserId ||
        source.userId ||
        source.contactId ||
        source.targetUserId ||
        ''
      const senderUserId = chat.senderUserId || source.senderUserId || ''

      const receiver = normalizeSnowflakeId(receiverUserId)
      const sender = normalizeSnowflakeId(senderUserId)

      // 关键：回复时不能把消息发给自己
      if (currentUserId && receiver && receiver === currentUserId) {
        return sender || ''
      }
      if (currentUserId && sender && sender === currentUserId) {
        return receiver || ''
      }
      // 无法判断时，优先使用 receiver
      return receiver || sender || ''
    },
    resolveReceiverName(chat) {
      if (!chat) return ''
      const source = chat.source || {}
      const currentUserId = normalizeSnowflakeId(this.currentUserId)
      const receiverUserId = normalizeSnowflakeId(chat.receiverUserId)
      const senderUserId = normalizeSnowflakeId(chat.senderUserId)
      const receiverName = chat.receiverName || source.receiverName || source.contactName || ''
      const senderName = chat.senderName || source.senderName || ''

      if (currentUserId && receiverUserId && receiverUserId === currentUserId) {
        return senderName || chat.name || source.name || ''
      }
      if (currentUserId && senderUserId && senderUserId === currentUserId) {
        return receiverName || chat.name || source.name || ''
      }
      return receiverName || senderName || chat.name || source.name || ''
    },
    resolveTypePairFromRouteQuery(query = {}) {
      const sendType = String(query?.sendType || '').trim().toLowerCase()
      const receiveType = String(query?.receiveType || '').trim().toLowerCase()
      const typeSet = new Set(['company', 'scheme', 'supplier'])
      return {
        sendType: typeSet.has(sendType) ? sendType : '',
        receiveType: typeSet.has(receiveType) ? receiveType : ''
      }
    },
    resolveConversationTypePair(chat) {
      const fromChatSend = String(chat?.sendType || '').trim().toLowerCase()
      const fromChatReceive = String(chat?.receiveType || '').trim().toLowerCase()
      if (fromChatSend && fromChatReceive) {
        return { sendType: fromChatSend, receiveType: fromChatReceive }
      }
      const sourceQuery =
        this.embedded && this.launchQuery
          ? this.launchQuery
          : (this.$route && this.$route.query ? this.$route.query : {})
      const q = parseSchemeDialogueRouteQuery(sourceQuery || {})
      const queryPair = this.resolveTypePairFromRouteQuery(q)
      if (queryPair.sendType && queryPair.receiveType) {
        return queryPair
      }
      const querySend = String(q.sendType || '').trim().toLowerCase()
      const queryReceive = String(q.receiveType || '').trim().toLowerCase()
      if (querySend && queryReceive) {
        return { sendType: querySend, receiveType: queryReceive }
      }
      const path = String((this.$route && this.$route.path) || '').toLowerCase()
      if (path.includes('/supplyecosystem')) {
        return { sendType: 'supplier', receiveType: 'company' }
      }
      return { sendType: 'scheme', receiveType: 'company' }
    },
    isSamePeerChat(chat, targetUserId) {
      const target = normalizeSnowflakeId(targetUserId)
      if (!chat || !target) return false
      const senderUserId = normalizeSnowflakeId(chat.senderUserId)
      const receiverUserId = normalizeSnowflakeId(chat.receiverUserId)
      const currentUserId = normalizeSnowflakeId(this.currentUserId)
      if (!currentUserId) {
        return senderUserId === target || receiverUserId === target
      }
      // 精准匹配“我 与 对方”的会话，避免同 entityId 下串会话
      return (
        (senderUserId === currentUserId && receiverUserId === target) ||
        (receiverUserId === currentUserId && senderUserId === target)
      )
    },
    /**
     * 首条消息前补齐发起方/类型对，使脱敏在发消息前即可生效。
     * @param {object} chat
     * @param {{ sourcePage?: string }} [context]
     * @returns {object}
     */
    prepareDraftConversation(chat, context = {}) {
      if (!chat) return chat
      const me = coerceSnowflakeString(this.currentUserId)
      if (!me) return chat

      const typePair = this.resolveConversationTypePair(chat)
      if (typePair.sendType) chat.sendType = typePair.sendType
      if (typePair.receiveType) chat.receiveType = typePair.receiveType

      const rUid = coerceSnowflakeString(chat.receiverUserId)
      const sUid = coerceSnowflakeString(chat.senderUserId)
      if (!rUid || rUid === me || (sUid && sUid !== me)) return chat

      if (!sUid) {
        chat.senderUserId = me
        if (!String(chat.senderName || '').trim()) {
          chat.senderName = this.resolveCurrentUserDisplayName()
        }
      }

      const source = String(
        context.sourcePage ||
        this.launchQuery?.sourcePage ||
        this.$route?.query?.sourcePage ||
        ''
      ).trim().toLowerCase()
      const isNewOpportunityReach =
        source.includes('opportunities') && !source.includes('ongoing')
      const sendType = String(chat.sendType || '').trim().toLowerCase()
      const receiveType = String(chat.receiveType || '').trim().toLowerCase()

      if (
        isNewOpportunityReach &&
        sendType === 'company' &&
        (receiveType === 'scheme' || receiveType === 'supplier')
      ) {
        chat.sendType = receiveType
        chat.receiveType = sendType
      }
      return chat
    }
  },
  async mounted() {
    if (typeof document !== 'undefined') {
      document.addEventListener('visibilitychange', this.onVisibilityChange)
    }
    try {
      const user = await fetchSchemeEcoCurrentUser()
      if (user) {
        const rawId = user.raw && (user.raw.id != null ? user.raw.id : user.raw.userId)
        this.currentUserId =
          coerceSnowflakeString(rawId) || coerceSnowflakeString(user.userId) || ''
        this.currentUserName =
          user.displayName ||
          user.raw?.name ||
          user.raw?.realName ||
          user.raw?.username ||
          user.companyName ||
          ''
      }
    } catch (e) {}
    const sourceQuery =
      this.embedded && this.launchQuery
        ? this.launchQuery
        : (this.$route && this.$route.query ? this.$route.query : {})
    const q = parseSchemeDialogueRouteQuery(sourceQuery || {})
    if (q.prefillText && !this.chatInput) {
      this.chatInput = String(q.prefillText)
    }
    const routeReceiver = await this.resolveRouteReceiver(q)
    if ((q.receiverUserId || q.receiverPhone) && !routeReceiver?.receiverUserId) {
      this.$message && this.$message.warning('找不到联系人，无法发起会话')
      return
    }
    const chats = await this.initChats(q.chatKind, q.entityId, routeReceiver)
    const sourceLabel = this.sourcePageLabel(q.sourcePage)
    const mergedChats = (chats || []).map((chat) => {
      if (!chat) return chat
      if (!routeReceiver) return chat
      const routeReceiverUserId = String(routeReceiver.receiverUserId || '')
      const sameEntity =
        q.entityId &&
        String(chat.entityId || '') === String(q.entityId || '') &&
        String(chat.chatKind || '') === String(q.chatKind || chat.chatKind || '')
      if (!sameEntity) return chat
      if (routeReceiverUserId && !this.isSamePeerChat(chat, routeReceiverUserId)) return chat
      const rtp = this.resolveTypePairFromRouteQuery(q)
      const mergedTypes = this.resolveConversationTypePair({
        ...chat,
        sendType: rtp.sendType || chat.sendType || '',
        receiveType: rtp.receiveType || chat.receiveType || ''
      })
      const base = {
        ...chat,
        sendType: mergedTypes.sendType || chat.sendType || '',
        receiveType: mergedTypes.receiveType || chat.receiveType || '',
        name: routeReceiver.receiverName || chat.receiverName || chat.name || '未命名联系人',
        receiverUserId: routeReceiver.receiverUserId || chat.receiverUserId || '',
        receiverName: routeReceiver.receiverName || chat.receiverName || chat.name || '',
        source: {
          ...(chat.source || {}),
          receiverUserId: routeReceiver.receiverUserId || chat.receiverUserId || '',
          receiverName: routeReceiver.receiverName || chat.receiverName || chat.name || '',
          mobilePhone: routeReceiver.receiverPhone || chat?.source?.mobilePhone || ''
        }
      }
      return this.prepareDraftConversation(
        this.decorateSubtitleWithSource(base, sourceLabel),
        { sourcePage: q.sourcePage || '' }
      )
    })
    this.chats = mergedChats
    this.reorderChats()
    await this.cleanupSystemUnreadConversations()
    this.unreadReady = true
    this.$emit('unread-change', Number(this.totalUnreadCount || 0))

    await this.loadMessagesForSelectedChat(true, !!this.dialogueVisible)
    this.connectWs()
    // 兜底轮询由 WS onopen/onclose 自动启停；这里确保初始断开时开启
    this.startPolling()
  },
  activated() {
    // keep-alive 场景：回到页面时恢复
    if (this.wsStatus !== 'CONNECTED') {
      this.connectWs()
      this.startPolling()
    }
  },
  deactivated() {
    // keep-alive 场景：离开页面时暂停一切后台请求
    this.closeWs()
    this.stopPolling()
  },
  beforeRouteLeave(to, from, next) {
    // 非 keep-alive 销毁前也确保停掉
    this.closeWs()
    this.stopPolling()
    next()
  },
  beforeDestroy() {
    // 先收起弹框，避免 append-to-body 的遮罩在组件被 v-if/路由切换突然卸载时残留
    this.dialogueVisible = false
    this.closeWs()
    this.stopPolling()
    if (typeof document !== 'undefined') {
      document.removeEventListener('visibilitychange', this.onVisibilityChange)
    }
  }
}
</script>

<style scoped>
.dialogue-center {
  --muted: #465568;
  --shadow-sm: 0 12px 30px rgba(15, 23, 42, 0.06);
  color: #111827;
  padding: 0;
  height: 78vh;
  min-height: 620px;
  overflow: hidden;
}

/deep/ .dialogue-center-modal {
  border-radius: 22px !important;
  overflow: hidden;
}

/deep/ .dialogue-center-modal .el-dialog__header {
  padding: 16px 20px 0;
}

/deep/ .dialogue-center-modal .el-dialog__body {
  padding: 12px 20px 20px;
}

.page {
  display: block;
  height: 100%;
}

.chat {
  display: grid;
  grid-template-columns: 360px 1fr 360px;
  gap: 18px;
  height: 100%;
  min-height: 0;
  align-items: stretch;
}

.left-rail,
.chat-main,
.right-rail {
  min-height: 0;
}

.left-rail {
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-height: 0;
}

.left-rail .chat-left {
  flex: 1;
}

.right-rail {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.chat-left,
.chat-main {
  display: flex;
  flex-direction: column;
  min-height: 0;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(226, 232, 240, 0.96);
  border-radius: 28px;
  overflow: hidden;
  box-shadow: var(--shadow-sm);
}

.search {
  padding: 18px 18px 16px;
  border-bottom: 1px solid #edf2f8;
  background: linear-gradient(180deg, #ffffff, #fbfdff);
}

.chat-list {
  padding: 14px;
  height: auto;
  flex: 1;
  overflow: auto;
  background: linear-gradient(180deg, #fbfdff, #ffffff);
}

.chat-item {
  padding: 16px 16px 15px;
  border-radius: 18px;
  cursor: pointer;
  margin-bottom: 10px;
  border: 1px solid transparent;
  transition: 0.22s;
  color: #111827;
}

.chat-item:hover {
  background: #f8fbff;
  border-color: #dbeafe;
}

.chat-item.active {
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  box-shadow: 0 12px 24px rgba(59, 130, 246, 0.08);
}

.chat-head {
  padding: 22px 24px;
  border-bottom: 1px solid #edf2f8;
  display: flex;
  justify-content: space-between;
  gap: 14px;
  align-items: flex-start;
  flex-wrap: wrap;
  background: linear-gradient(180deg, #ffffff, #fbfdff);
}

.msgs {
  padding: 24px;
  height: auto;
  flex: 1;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: #f3f4f6;
}

.sys-row {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 4px 0;
}

.sys-bubble {
  max-width: min(680px, 92%);
  padding: 8px 12px;
  border-radius: 999px;
  background: rgba(226, 232, 240, 0.92);
  border: 1px solid rgba(203, 213, 225, 0.92);
  color: #475569;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.6;
  text-align: center;
  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.06);
}

.msg-row {
  width: 100%;
  display: flex;
  gap: 10px;
  align-items: flex-end;
  max-width: 100%;
  justify-content: flex-start;
}

.msg-row.me {
  flex-direction: row-reverse;
  justify-content: flex-start;
}

.msg-row.other {
  flex-direction: row;
}

.msg-avatar {
  width: 34px;
  height: 34px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.10);
  border: 1px solid rgba(255, 255, 255, 0.60);
}

.msg-avatar.me {
  background: linear-gradient(135deg, #4f46e5, #2563eb);
  color: #fff;
}

.msg-avatar.other {
  background: linear-gradient(135deg, #e2e8f0, #cbd5e1);
  color: #0f172a;
}

.msg-avatar-text {
  font-weight: 900;
  font-size: 13px;
  line-height: 1;
}

.msg-bubble {
  position: relative;
  max-width: min(640px, 78%);
  padding: 10px 14px;
  border-radius: 14px;
  font-size: 13px;
  line-height: 1.7;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.07);
  word-break: break-word;
  white-space: pre-wrap;
  border: 1px solid rgba(15, 23, 42, 0.06);
}

.msg-bubble.me {
  background: linear-gradient(135deg, #12b981 0%, #06b6d4 100%);
  color: #ffffff;
  border-color: rgba(255, 255, 255, 0.22);
}

.msg-bubble.other {
  background: rgba(255, 255, 255, 0.96);
  color: #111827;
}

.msg-bubble.is-image,
.msg-bubble.is-file {
  padding: 6px;
}

.msg-bubble.is-image {
  background: transparent !important;
  border-color: transparent !important;
  box-shadow: none;
}

.chat-send {
  padding: 16px 18px 18px;
  border-top: 1px solid #edf2f8;
  display: flex;
  gap: 12px;
  align-items: flex-end;
  background: #fff;
}

.composer {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 999px;
  background: #f6f7fb;
  border: 1px solid rgba(15, 23, 42, 0.06);
}

.attach-upload {
  display: inline-flex;
}

.composer-input {
  flex: 1;
}

.dialogue-center /deep/ .composer-input .el-textarea__inner {
  background: transparent;
  border: none;
  box-shadow: none;
  resize: none;
  padding: 0;
  min-height: 28px !important;
  line-height: 1.6;
}

.composer-btn {
  height: 42px;
  width: 42px;
  border-radius: 999px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  background: #ffffff;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  user-select: none;
}

.composer-btn:hover {
  border-color: rgba(59, 130, 246, 0.30);
}

.composer-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.composer-plus {
  font-size: 22px;
  line-height: 1;
  margin-top: -2px;
  color: #0f172a;
}

.composer-btn-right {
  background: #4f46e5;
  border-color: transparent;
  color: #ffffff;
  font-weight: 900;
  font-size: 18px;
}

.composer-btn-right:hover {
  filter: brightness(1.02);
}

.chat-image {
  display: block;
  max-width: 240px;
  max-height: 240px;
  border-radius: 10px;
  object-fit: cover;
  cursor: zoom-in;
  border: 1px solid rgba(15, 23, 42, 0.06);
}

.preview-image {
  max-width: 100%;
  max-height: 70vh;
  border-radius: 14px;
  object-fit: contain;
}

.chat-file {
  display: inline-flex;
  flex-direction: column;
  gap: 2px;
  text-decoration: none;
  color: inherit;
}

.chat-file-name {
  font-weight: 800;
}

.chat-file-tip {
  font-size: 12px;
  opacity: 0.75;
}

.msg-link {
  color: #2563eb;
  text-decoration: underline;
  word-break: break-all;
}

.msg-link:hover {
  color: #1d4ed8;
}

.sub {
  margin-top: 6px;
  font-size: 12px;
  color: var(--muted);
  font-weight: 500;
  line-height: 1.75;
}

.btn {
  padding: 11px 16px;
  border-radius: 15px;
  border: none;
  font-weight: 800;
  letter-spacing: 0.01em;
}

.btn-primary {
  background: linear-gradient(135deg, #2563eb 0%, #398bff 55%, #6d7dff 100%);
  color: #fff;
  box-shadow: 0 16px 30px rgba(37, 99, 235, 0.25);
}

.btn-secondary {
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid #d7e2f1;
  color: #334155;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.05);
}

.btn-secondary:hover {
  border-color: #b7cae6;
  color: #1d4ed8;
  background: #f7fbff;
}

.badges {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 12px;
}

.badge {
  padding: 6px 11px;
  border-radius: 999px;
  background: #f5f8fd;
  border: 1px solid #dbe5f1;
  font-size: 12px;
  font-weight: 800;
  color: #415164;
  display: inline-flex;
  align-items: center;
}

.badge.blue {
  background: #eff6ff;
  border-color: #bfdbfe;
  color: #1d4ed8;
}

.dialogue-center /deep/ .el-input__inner,
.dialogue-center /deep/ .el-textarea__inner {
  border-radius: 16px;
}

.dialogue-center /deep/ .el-textarea__inner {
  line-height: 1.8;
}

.textarea-like /deep/ textarea {
  min-height: 52px !important;
  max-height: 120px;
}

@media (max-width: 1200px) {
  .dialogue-center {
    height: auto;
    min-height: 0;
    overflow: visible;
  }
  .chat {
    grid-template-columns: 1fr;
    height: auto;
  }
}
</style>
